exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quality-edit .quality-edit-table[data-v-a99847e2] .ivu-table-tbody .ivu-form-item{margin-bottom:0}", ""]);

// exports
